import type { RegisteredSkill } from '../types'
import { createListSkillsHandler } from './handlers/list-skills-handlers'

export function createListSkillsSkill(getAllSkills: () => RegisteredSkill[]): RegisteredSkill {
  return {
    name: 'list_skills',
    description:
      'Returns the catalog of all skills the add-in can execute, with args and result schemas.',
    argsSchema: {
      type: 'object',
      properties: {},
      additionalProperties: false,
    },
    resultSchema: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          name: { type: 'string' },
          description: { type: 'string' },
          argsSchema: { type: 'object' },
          resultSchema: { type: 'object' },
        },
        required: ['name', 'description', 'argsSchema', 'resultSchema'],
      },
    },
    handler: createListSkillsHandler(getAllSkills),
  }
}
